
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__container{box-sizing:border-box;position:relative}.splide__list{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;box-sizing:border-box;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}:host{
  position:relative;
  padding:var(--spacing-12) 0;
}:host outline-cta-card{
    color:var(--brand-dark-blue-900);
    min-height:100%;
  }:host outline-cta-card div[slot='icon'],
    :host outline-cta-card div[slot='heading'],
    :host outline-cta-card div[slot='body'],
    :host outline-cta-card div[slot='cta']{
      padding:0 var(--spacing-10);
      padding:0 var(--cta-slot-padding-x, var(--spacing-10));
    }@media (min-width: 768px){:host outline-cta-card div[slot='icon'],
    :host outline-cta-card div[slot='heading'],
    :host outline-cta-card div[slot='body'],
    :host outline-cta-card div[slot='cta']{
        padding:0
    }
      }:host outline-cta-card div[slot='heading']{
      color:var(--brand-dark-blue-900);
    }:host outline-cta-card .content{
      padding:var(--spacing-5) var(--spacing-10);
    }:host outline-cta-card[high-contrast]{
    color:var(--brand-white);
  }:host outline-cta-card[high-contrast] div[slot='heading'],
    :host outline-cta-card[high-contrast] div[slot='body']{
      color:var(--brand-white);
    }:host[has-title]{
    padding-top:0;
  }.splide{
  position:relative;
}.splide__pagination{
  display:flex;
  justify-content:center;
  align-items:center;
  margin:0;
  padding:0;
  list-style-type:none;
}.splide__pagination__page{
  border:var(--outline-ring-width) solid var(--brand-dark-blue-900);
  cursor:pointer;
  display:block;
  width:1.5rem;
  height:1.5rem;
  padding:0;
  background:transparent;
  border-radius:50%;
  margin:0 var(--spacing-2);
  font-size:0;
}.splide__pagination__page.is-active{
  border-color:var(--brand-primary-dark-blue);
  background:var(--brand-primary-dark-blue);
}.splide__arrow{
  background:var(--brand-primary-blue);
  border:var(--outline-ring-width) solid var(--brand-primary-dark-blue);
  border-radius:8px;
  width:3rem;
  height:3rem;
  padding:0;
  position:absolute;
  bottom:0;
  top:50%;
  transform:translateY(-50%);
  z-index:40;
  display:flex;
  justify-content:center;
  align-items:center;
  cursor:pointer;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, outline, outline-color;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
  text-decoration-line:none;
  outline:none;
}.splide__arrow:disabled{
    display:none;
  }.splide__arrow:hover{
    transform:translateY(-50%) scale(1.05);
  }.splide__arrow:focus{
    background-color:var(--brand-bright-blue-900);
    color:var(--brand-dark-blue-900);
    outline:2px solid var(--brand-dark-blue-900);
    outline-offset:2px;
  }.splide__arrow svg{
  fill:var(--brand-primary-dark-blue);
  width:1.25rem;
}.splide__arrow--next{
  right:-0.5rem;
}@media (min-width: 768px){.splide__arrow--next{
    right:-2rem
}
  }.splide__arrow--prev{
  left:-0.5rem;
}@media (min-width: 768px){.splide__arrow--prev{
    left:-2rem
}
  }.splide__arrow--prev svg{
    transform:rotate(180deg);
  }.splide__slide{
  padding:var(--spacing-6) var(--spacing-2);
}@media (min-width: 768px){.splide__slide{
    padding:var(--spacing-12) var(--spacing-2)
}
  }.splide__slide.is-visible{
  visibility:visible;
}.sr-only{
  position:absolute !important;
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  width:1px;
  height:1px;
  word-wrap:normal;
}.slide-count{
  visibility:hidden;
}@media (min-width: 768px){
  .splide__arrow{justify-content:center}
    .splide__arrow--prev:after{
      top:1.25rem;
    }
}button.trigger:focus .play-overlay .btn, button.trigger:focus-within .play-overlay .btn{
    background-color:var(--outline-button--primary-bg-color-focus--computed);
    color:var(--outline-button--primary-color-focus--computed);
    font-weight:var(--outline-button--primary-weight-focus--computed);
    outline:2px solid var(--outline-button-accent-color);
    outline-offset:2px;
  }
`;